export enum SignatureType {
    ADOBE,
    DOCUSIGN
}